import { api } from "../index";

const MAPS_ENDPOINT = "/maps";
interface PlacePrediction {
	description: string;
	place_id: string;
}
export const MapsAPI = api.injectEndpoints({
	endpoints: build => ({
		getAutoCompleteSuggestions: build.query<
			{ predictions: PlacePrediction[] },
			{ input: string; sessiontoken: string; components: string }
		>({
			query: ({ input, sessiontoken, components }) => ({
				url: `${MAPS_ENDPOINT}/places/autocomplete`,
				params: { input, sessiontoken, components },
				method: "GET"
			})
		}),
		getPlaceDetails: build.query<
			{ result: { geometry: { location: { lat: number; lng: number } } } },
			{ place_id: string; sessiontoken: string }
		>({
			query: ({ place_id, sessiontoken }) => ({
				url: `${MAPS_ENDPOINT}/place/details`,
				params: { place_id, sessiontoken },
				method: "GET"
			})
		}),
		getReverseGeocode: build.query<
			{
				results: google.maps.GeocoderResult[];
			},
			{ lat: number; lng: number }
		>({
			query: ({ lat, lng }) => ({
				url: `${MAPS_ENDPOINT}/place/reverseGeocode`,
				params: { lat, lng },
				method: "GET"
			})
		})
	})
});

export const { useLazyGetAutoCompleteSuggestionsQuery, useLazyGetPlaceDetailsQuery, useLazyGetReverseGeocodeQuery } =
	MapsAPI;
